<template>
  <span
    class="relative"
    @click.capture="toggleTooltip"
  >
    <i
      class="fas fa-question-circle ml-1"
      :class="{'hidden': !defaultTooltip }"
      v-if="showDefaultTooltip || (!showDefaultTooltip && !noPermission)"
      v-tooltip="defaultTooltip"
    ></i>

    <span v-else>
      <img
        :name="String(_uid)"
        src="@/assets/images/pro.svg"
        class="ml-1 inline-block mb-1"
        :class="{'cursor-pointer': noPermission }"
      >
      <aha-toggle-tip
        ref="upgrade-icon-tooltip"
        :to="String(_uid)"
        showIcon
        :buttonText="$i18nPresenter.t('Upgrade')"
        showClose
        hideTooltipAfterClick
        theme="dark"
        placement="top"
        @click="openPlanUpgradeModal"
      >
        <template #custom-content>
          <p v-if="defaultTooltip && typeof defaultTooltip === 'string'" class="default-tooltip">
            {{ defaultTooltip }}
          </p>
          <p
            v-if="defaultTooltip && defaultTooltip.content && defaultTooltip.html"
            class="default-tooltip"
            v-html="defaultTooltip.content"
          ></p>
          <span v-html="$i18nPresenter.t('upgradeMessagePricingTooltip', { upgradePlan })"></span>
        </template>
      </aha-toggle-tip>
    </span>
  </span>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import Util from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  name: 'IconNeedUpgradePlan',
  props: {
    noPermission: {
      type: Boolean,
      default: false,
    },
    defaultTooltip: {
      type: [String, Object],
      default: () => '',
    },
    upgradePlan: {
      type: String,
      default: '',
    },
    featureName: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: eventCategories.PRESENTATION_EDITOR,
    },
  },
  data() {
    return {
      isShowTooltip: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    showDefaultTooltip() {
      if (this.noPermission) return false
      if (!this.defaultTooltip) return false
      return true
    },
  },
  methods: {
    toggleTooltip() {
      const tooltip = this.$refs['upgrade-icon-tooltip']
      if (!tooltip) return
      if (!this.noPermission) return
      tooltip.show()
    },
    openPlanUpgradeModal() {
      this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
      Util.mixpanelTracking(
        this.source,
        'Feature upgrade',
        `${this.featureName}`,
        null,
        {
          presentationId: this.$store.state.presentation.id,
          userId: this.$store.state.currentUser.id,
          plan: this.$store.state.currentUser.plan,
        },
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.default-tooltip {
  margin-bottom: 8px !important;
}

.fa-question-circle {
  color: #b7b7b7;
}
</style>
